
import Module404 from '@/components/modules/Module404.vue';
export default {
  components: {
    Module404
  }
};
